import f1 from '@eab-pip/pi-f1';

export class DelegateKBI {
  constructor() {}

  static show(settings: object) {
    const knowledgeBotId = `eab-knowledge-bot-interface`;
    const kbiEl = this.getKBI();

    kbiEl.id = knowledgeBotId;
    kbiEl.classList.add('overlay');

    const _settings = settings ?? {};
    for (const k in _settings) {
      (kbiEl as any)[k] = (_settings as any)[k];
    }

    // if we invoke through the delegate then we should show the close button
    //
    f1.write('/settings/hidden/heading_close', false, kbiEl);
    return this;
  }

  static hide() {
    const kbiEl = this.getKBI();

    kbiEl.remove();
    return this;
  }

  static getKBI() {
    const _knowledgeBotEl = document.body.querySelector('eab-nav-knowledge-bot');
    if (_knowledgeBotEl) {
      return _knowledgeBotEl;
    }

    const kbiEl = document.createElement('eab-nav-knowledge-bot');
    document.body.appendChild(kbiEl);
    return kbiEl;
  }

  static instance() {
    return this;
  }
}
